import { render, staticRenderFns } from "./SingleColorPicker.vue?vue&type=template&id=1770608e&"
import script from "./SingleColorPicker.vue?vue&type=script&lang=js&"
export * from "./SingleColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./SingleColorPicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports